import { css } from '@emotion/react'

import { colors, colorTheme } from '~/@common/styles'
import type { RadioGroupInputProps } from '../group/RadioGroupInput'
import { radioGroupItemFactory } from '../group/RadioGroupItem'

export const ChipRadioGroupItem = (props: RadioGroupInputProps) =>
  radioGroupItemFactory(
    props,
    'ChipRadioGroupItem',
    css`
      label {
        cursor: pointer;
        width: 37px;
        height: 39px;
        border-radius: var(--Radius-200);
        padding: 9px 12px;
        background-color: ${colors.white};
        border: 1px solid ${colors.gray.$400};
      }

      input:checked + label {
        background-color: ${colors.blue.$110};
        border-color: ${colorTheme.primary};
      }

      /* SOLO 미구독 등 비활성 상태 — 클릭 차단 + 시각적 dim 처리 */
      input:disabled + label {
        cursor: not-allowed;
        background-color: ${colors.gray.$100};
        border-color: ${colors.gray.$300};
        color: ${colors.gray.$400};
        opacity: 0.6;
      }
    `,
  )
